import moment from 'moment';

export default function getFlatDate(date) {
  return moment(date).format('MMMM Do YYYY');
}
